
<div class="panel panel-primary panel-info" data-testid="manual-entry-page">
    <div class="panel-heading">
        <h2>{{picketLineName}} - Manual Entry</h2>
    </div>
    <div class="panel-body">
        <form class="form-horizontal" role="form">
           <div class="col-md-6 pull-right">
                <div class="alert alert-info">
                    <span class="control-label">Added Records </span>
                </div>

                <div class="table-responsive" *ngIf="manualRecords.length > 0">
                    <table class="table table-striped table-condensed">
                        <thead>
                            <tr>
                                <th>SlNo</th>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Walk Date</th>
                                <th>SignIn</th>
                                <th>SignOut</th>
                                <th>Duration</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let rec of manualRecords.reverse().slice(0,5)">
                                <td>{{rec.SlNo}}</td>
                                <td>
                                    <div *ngIf="rec.ImageExists">
                                        <img class="thumbnail" width="75px" height="50px" [src]="'Content/images/members/' + rec.MemberId + '.jpg'" alt="{{rec.MemberId}}">
                                        <br />
                                        {{rec.MemberId}}
                                    </div>
                                    <div *ngIf="!rec.ImageExists">{{rec.MemberId}}</div>
                                </td>
                                <td>{{rec.Name}} </td>
                                <td>{{rec.WalkDate | date:"MM/dd/yyyy"}}</td>
                                <td>{{rec.SignIn | date:"h:mma"}} </td>
                                <td>{{rec.SignOut | date:"h:mma"}} </td>
                                <td>{{rec.Hours+' hrs '+ rec.Minutes + ' min.'}} </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="alert alert-info text-center clock col-xs-12 col-sm-12 col-md-12">

                    </div>
                    <div [formGroup]="memberSearchForm" class="input-group input-group-sm col-xs-12 col-sm-12 col-md-12">
                        <label for="inputSearchMembers" class="control-label">Scan/Enter Member Card here ...</label>
                        <input
                            name="inputSearchMembers"
                            id="inputSearchMembers"
                            #searchBox
                            (focus)="true"
                            type="search"
                            formControlName="filterMember"
                            class="form-control shortInputSearch"
                            placeholder="Filter.."
                            (keyup.enter)="searchMbr();"
                            data-testid="member-search-box">
                        <div class="input-group-btn">
                            <button class="btn btn-primary" (click)="searchMbr();" data-testid="member-search-button"><i class="glyphicon glyphicon-search"></i></button>
                            <button class="btn btn-primary" (click)="clearSearchMbr();"><i class="glyphicon glyphicon-remove-sign"></i></button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-6 pull-left">
                        <div *ngIf="member.ImageExists">
                            <img class="thumbnail img-responsive" width="250px" height="320px" [src]="'Content/images/members/' +member.MemberId + '.jpg'" alt="{{member.MemberId}}">
                            <br />
                            <span
                            class="control-label">{{member.MemberId}}</span>
                        </div>
                        <div *ngIf="!member.ImageExists">{{member.MemberId}}</div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6 pull-right"  *ngIf="member.MemberId">
                        <h2 data-testid="member-name">{{member.FirstName + ' ' + member.MiddleName + ' ' + member.LastName}}</h2>
                        <br />
                        <span class="control-label" data-testid="member-phone"><i>{{'Ph.  ' + member.Phone}}</i></span>
                    </div>
                </div>
                <hr /><hr />
                <div class="row">
                    <div class="col-md-2">

                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-4">
                        <label for="startDate" class="control-label">Date of the Walk:</label>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6">
                        <p class="input-group">
                            <input
                                type="text"
                                class="form-control"
                                name="startDate" 
                                data-testid="manual-entry-start-date" 
                                id="startDate" 
                                validate-on="blur"
                                required required-message="'Start Date is required'"
                                bsDatepicker
                                [bsConfig]="{ containerClass: 'theme-red', dateInputFormat:'YYYY-MM-DD'}"
                                #dp="bsDatepicker"
                                [(ngModel)]="newManualEntry.WalkDate" />
                            <span class="input-group-btn">
                                <button type="button" class="btn btn-default" (click)="dp.show()"><i class="glyphicon glyphicon-calendar"></i></button>
                            </span>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">

                    </div>
                    <div class="col-xs-6 col-sm-6 col-md-4 fa-align-center">
                        <label for="signInTime" class="timepicker-title label label-primary">Sign-in Time:</label>
                        <timepicker
                            name="signInTime"
                            id="signInTime"
                            data-testid="manual-entry-start-time"
                            [(ngModel)]="newManualEntry.SignInTime"
                            [hourStep]="1"
                            [minuteStep]="1"
                            show-meridian="true"
                            defaultTime="00:00">
                        </timepicker>
                    </div>
                    <div class="col-xs-6 col-sm-6 col-md-4 pull-right fa-align-center">
                        <label for="signOutTime" class="timepicker-title label label-warning">Sign-out Time:</label>
                        <timepicker
                            data-testid="manual-entry-end-time"
                            name="signOutTime"
                            id="signOutTime"
                            [(ngModel)]="newManualEntry.SignOutTime"
                            [hourStep]="1"
                            [minuteStep]="1"
                            show-meridian="true">
                        </timepicker>
                    </div>

                </div>

                <div class="row">
                    <div style="padding-left:10px;padding-right:10px;">
                        <label for="comments" class="control-label">Comments : </label>
                        <textarea
                            data-testid="manual-entry-comment"
                            class="form-control"
                            [(ngModel)]="newManualEntry.Comments"
                            name="comments"
                            id="comments"
                            rows="3"
                            required></textarea>
                    </div>
                </div>
                <br />
                <div class="pull-left">
                    <button
                        type="button"
                        class="btn btn-primary"
                        (click)="addManualEntry()"
                        [disabled]="sendingRecord === true || member.MemberId === '' || newManualEntry.SignInTime === null || newManualEntry.SignOutTime === null"
                        data-testid="add-manual-entry-next-mbr">Save & Clear Member</button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        (click)="addSameMbrManualEntry()"
                        [disabled]="sendingRecord === true || member.MemberId === '' || newManualEntry.SignInTime === null || newManualEntry.SignOutTime === null "
                        data-testid="add-manual-entry-same-mbr">Save</button>
                    <a [routerLink]="['/strikes/',strikeId]">Back to Strike </a>
                </div>
            </div>
        </form>
    </div>
    <div class="panel-footer clearfix">
    </div>
</div>
